
import SettingDeliveryPoint from "components/DeliveryPoint";
import NotFooterLayout from "layouts/NotFooterLayout";

function DeliveryPointPage() {

  return (
    <NotFooterLayout namePage="จัดการจุดจอด"   >
      <div className="layout-content">
        <SettingDeliveryPoint />
      </div>
    </NotFooterLayout>
  );
}

export default DeliveryPointPage;